var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.isActive
      ? _c("div", {
          staticClass: "click-area",
          on: { click: _vm.toggleDropdown },
        })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "category-filter" }, [
      _vm.isActive
        ? _c(
            "span",
            {
              staticClass: "close",
              on: {
                click: function ($event) {
                  return _vm.toggleDropdown()
                },
              },
            },
            [_vm._v("X\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ul",
        {
          staticClass: "dropdown",
          class: { active: _vm.isActive },
          attrs: { id: "container" },
        },
        [
          _c(
            "li",
            {
              on: {
                click: function ($event) {
                  return _vm.toggleDropdown()
                },
              },
            },
            [
              _vm.value != ""
                ? [
                    _c("strong", { key: 1 }, [
                      _c("span", [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.sortingTitle) +
                            "\n            "
                        ),
                      ]),
                    ]),
                  ]
                : [
                    _c("div", [
                      _c("strong", [
                        _vm._v("Sort by "),
                        _c("span", [_vm._v(_vm._s(_vm.selectedItem))]),
                      ]),
                    ]),
                  ],
            ],
            2
          ),
          _vm._v(" "),
          _vm._l(_vm.items, function (item, index) {
            return _c(
              "li",
              {
                key: index,
                class: { active: _vm.value.includes(item) },
                on: {
                  click: function ($event) {
                    return _vm.selectItem(item)
                  },
                },
              },
              [_c("strong", [_vm._v(_vm._s(item.label))])]
            )
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }